import { useTranslation } from "react-i18next";
import { Controller, useFormContext } from "react-hook-form";
import { Box, FormLabel, FormControl, Typography, Checkbox, FormHelperText, CircularProgress } from "@mui/material";

import { useGoalngoSports } from "../../../Entity/api/queries/useSports";
import { EntityBranchFormData } from "../../../Entity/types/entityBranch.types";

const SportsTab = ({ isBranchDataLoading }: { isBranchDataLoading: boolean }) => {
  const { t } = useTranslation("profiles", { keyPrefix: "entityProfileEditBranch" });

  const { control } = useFormContext<EntityBranchFormData>();

  const { data: sports, isLoading: isSportsLoading } = useGoalngoSports();

  const handleSportToggle = (sportId: number, currentSports: number[], onChange: (value: number[]) => void) => {
    const isSelected = currentSports.includes(sportId);
    onChange(isSelected ? currentSports.filter((id) => id !== sportId) : [...currentSports, sportId]);
  };

  const isSectionLoading = isBranchDataLoading || isSportsLoading;
  return (
    <Box sx={styles.container}>
      <Typography sx={styles.title}>{t("sports")}</Typography>

      {isSectionLoading && <CircularProgress sx={styles.loading} />}
      {!isSectionLoading && sports && (
        <Controller
          name="sports"
          control={control}
          render={({ field: { value = [], onChange }, fieldState: { error } }) => {
            return (
              <FormControl error={!!error}>
                <Box sx={styles.sportsGrid}>
                  {sports.map(({ id, name }) => (
                    <Box key={id} sx={styles.sportItem}>
                      <Checkbox
                        size="small"
                        checked={value.includes(id)}
                        onChange={() => handleSportToggle(id, value, onChange)}
                      />
                      <FormLabel sx={styles.sportLabel}>{name}</FormLabel>
                    </Box>
                  ))}
                </Box>
                {error && <FormHelperText>{t(error.message)}</FormHelperText>}
              </FormControl>
            );
          }}
        />
      )}
    </Box>
  );
};

export default SportsTab;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    padding: "0 16px",
  },
  title: {
    color: "var(--Gray-900, #101828)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
  },
  sportsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
    gap: "16px",
  },
  sportItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  sportLabel: {
    color: "var(--Gray-700, #344054)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
  },
  loading: {
    margin: "50px auto",
  },
};
